import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { ROLES } from '../../../constants/enums'
import config from '../../../config'
import {
  getUserType
} from 'utils/token'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { withRouter } from 'react-router'

const enhance = compose(
  withRouter,
  connect(
    ({ auth }) => ({
      user: get(auth, 'user')
    }),
        { push }
    )
)

class InitPage extends Component {
  static propTypes = {
    location: PropTypes.object,
    push: PropTypes.func,
    user: PropTypes.object.isRequired
  }

  componentDidMount() {
    const { user, location } = this.props

    this.preventLoadingMainPage(user, location)
  }

  preventLoadingMainPage = (user, location) => {
    const userType = user && getUserType(user)

    if(userType){
      const canBePageLoaded = userType === ROLES.PARTICIPANT.u
      const pathname = get(location, 'pathname')
      if (!canBePageLoaded &&  pathname &&
        (pathname.startsWith('/dashboard') || pathname.startsWith('/fo/dashboard')) &&
        (pathname !== '/forbidden')) {
        this.props.push(`${config.publicPath}/forbidden`)
      }
    }
  }

  render() {
    return (<div></div>)
  }
}

export default enhance(InitPage)
